import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["deviceIdOnUrl"];
import { getHistory } from 'quartz-routing/service';
import tempStorage from 'usage-tracker-core/containers/tempStorage';
import { getTrackingClient } from './dependencies';
import { removeUuidFromUrl, resetAmplitudeStorageIfNeeded } from '../deviceIdOnUrl';
export const getBaseTrackingClient = _ref => {
  let {
      deviceIdOnUrl = false
    } = _ref,
    user = _objectWithoutPropertiesLoose(_ref, _excluded);
  const client = getTrackingClient({
    storage: tempStorage,
    user
  });
  if (!deviceIdOnUrl) {
    return client;
  }
  return Object.assign({}, client, {
    getDeviceId: () => {
      const history = getHistory();
      const searchParams = new URLSearchParams(history.location.search);

      // Authenticated mode: strip Device ID from URL and clear anonymous session so next session starts fresh.
      const removedUuid = removeUuidFromUrl(searchParams, history);
      if (removedUuid !== undefined) {
        resetAmplitudeStorageIfNeeded(removedUuid);
      }
      return client.getDeviceId();
    }
  });
};